import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

export type InterTabCommunicationParams = {[key: string]: any};

@Injectable({providedIn: "root"})
export class InterTabCommunicatorService {
  suppressed: string[] = [];
  cookieSubject: BehaviorSubject<InterTabCommunicationParams> = new BehaviorSubject<InterTabCommunicationParams>({});
  subjects: {[key: string]: BehaviorSubject<any>} = {};

  constructor() {
    this.exec();

    setInterval(() => this.exec(), 500);
  }

  observe(key: string) {
    if (!this.subjects[key] || this.subjects[key].closed) {
      const cookies = this.read();
      const value = cookies[key];
      this.subjects[key] = new BehaviorSubject<any>(value);
    }

    return this.subjects[key];
  }

  exec() {
    const cookies = this.read();

    Object.keys(this.subjects)
      .forEach((key) => {
        if (this.subjects[key].closed) return;
        if (this.suppressed.indexOf(key) >= 0) return;
        this.subjects[key].next(cookies[key]);
      });

    this.cookieSubject.next(cookies);

    this.suppressed = [];
  }

  read() {
    const cookies = document.cookie.split(/;\s*/)
      .reduce(
        (obj, str) => {
          let [, key, value] = str.match(/^([^=]+)=(.*)$/) || [null, null, null];

          if (!key || obj[key]) return obj;

          if (value[0] === "\"") {
            value = value.slice(1, -1);
          }

          value = decodeURIComponent(value);

          obj[key] = value;

          return obj;
        },
        {},
      );

    const itc = cookies["itc"] || "{}";

    if (itc && itc[0] === "[") return {};

    try {
      return JSON.parse(itc);
    } catch (err) {
      return {};
    }
  }

  send(key: string, value: any) {
    const data = this.read();
    data[key] = value;

    this.suppressed.push(key);
    const encoded = encodeURIComponent(JSON.stringify(data));
    document.cookie = `itc=${encoded}; path=/`;
  }
}
